import { Form } from "antd";
import { useEffect, useState } from "react";
import { requetsProviderSimulation } from "../../../../redux/slices/simulation/simulationAction";

export const useFieldsProviderSimulation = (dispatch, formState) => {
    const [form] = Form.useForm();
    const [checkHours, setCheckHours] = useState(false);

    const onFinish = (values, updateProject) => {
        dispatch(requetsProviderSimulation(values, updateProject));
    };

    useEffect(() => {
        form.setFieldsValue({
            ...formState,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formState]);

    return { form, onFinish, checkHours, setCheckHours };
};
